import { FunctionComponent } from "react";
import { Page } from "../layout/page";
import { IProps } from "./no-match.types";

/**
 * Page rendered when any route is not matched.
 * @returns {JSX.Element} The NoMatch component displaying a 404 page.
 */
const NoMatch: FunctionComponent<IProps> = () => {
    return (
        <Page name="not-found">
            <Page.Header title="Page not found" />
        </Page>
    );
};

export { NoMatch };
